var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"item",attrs:{"data-school":_vm.school,"job-id":_vm.school.jobId,"data-value":_vm.school.jobId}},[_c('div',{staticClass:"ui small header"},[_c('div',{staticClass:"content"},[_vm._v(" "+_vm._s(_vm.jobName)+" "),_c('div',{staticClass:"sub header"},[_vm._v(_vm._s(_vm.orgName))])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }